export default {
  methods: {
    baseLocaleUrl() {
      const baseUrl = global.BASE_URL || process.env.VUE_APP_BASE_URL;
      return `${baseUrl}${baseUrl.includes('.locale') ? '/app_dev.php' : ''}/${this.$i18n.locale.replace('-', '_')}`;
    },
  },
};
